module.exports = __webpack_public_path__ + "static/img/14000169.ebe20adc.png";